import { Component , HostBinding } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TrackingDirective } from '../helpers/directive/tracking.directive';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    standalone: true,
    imports: [TrackingDirective, RouterLink]
})
export class FooterComponent {

  @HostBinding('style.width') public readonly WIDTH = '100%';

  title = 'webapp';
}
